module.exports = __webpack_public_path__ + "media/bootstrap-icons/list-ul-c5ecb93f.svg";